module.exports = __webpack_public_path__ + "img/windmill.0d125076.webp";